module.exports = __webpack_public_path__ + "img/layout-3.7a769b66.jpg";